import { render } from "./RemoveFailedPaymentsButton.vue?vue&type=template&id=1e61df65"
import script from "./RemoveFailedPaymentsButton.vue?vue&type=script&lang=js"
export * from "./RemoveFailedPaymentsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__